import { useState } from "react";
import { BackButton } from "../components/backButton.jsx";
import { HeadLogo } from "../components/headLogo.jsx";
import { Spinner } from "../components/spinner.jsx";

function LoginView({ onLogin, onSignUp, onForgot,loading }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");



  return (
    <div className="centerView">
      <HeadLogo />
      <BackButton />
      <div className="container">
        <div className="header">Welcome back</div>
        <div className="getstarted">
          Enter your email and password to begin the hunt!
        </div>

        <div className="logininput">
          <input
            className="emailinput"
            type="email"
            placeholder="Enter email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>

        <div className="logininput">
          <input
            className="passwordinput"
            type="password"
            placeholder="Enter password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>

        
        {loading ? (
          <Spinner />
        ) : (
          <div>
            <button
              className="signup-login-button"
              onClick={() => onLogin(email, password)}
            >
              Log In
            </button>
            <button className="signup-login-button redo" onClick={onSignUp}>
              Sign Up
            </button>
          </div>
        )}
        <button className="signup-login-reset" onClick={onForgot}>
          Forget your password?
        </button>
      </div>
    </div>
  );
}

export { LoginView };
